<div class="cmdk__panel">
  <mat-form-field appearance="outline" class="cmdk__search">
    <mat-label>Search</mat-label>
    <mat-icon matIconPrefix>search</mat-icon>
    <input
      #searchEl
      matInput
      type="text"
      autocomplete="off"
      spellcheck="false"
      [formControl]="query"
      placeholder="Type to search…"
    />
  </mat-form-field>

  @if (filtered().length === 0) {
    <div class="cmdk__empty">No matches.</div>
  } @else {
    <div class="cmdk__results" role="listbox">
      @for (g of groups(); track g.group) {
        <div class="cmdk__group">{{ g.group }}</div>
        @for (item of g.items; track item.id) {
          <button
            type="button"
            class="cmdk__item"
            role="option"
            [attr.aria-selected]="indexOf(item) === highlightIndex()"
            [class.is-active]="indexOf(item) === highlightIndex()"
            (click)="select(item)"
            (mouseenter)="highlightIndex.set(indexOf(item))"
          >
            <app-icon [name]="item.icon" [size]="16" />
            <span class="cmdk__label">{{ item.label }}</span>
            @if (item.hint) {
              <span class="cmdk__hint">{{ item.hint }}</span>
            }
          </button>
        }
      }
    </div>
  }

  <footer class="cmdk__footer">
    <span>
      <kbd>↑↓</kbd>
      navigate
    </span>
    <span>
      <kbd>↵</kbd>
      open
    </span>
    <span>
      <kbd>Esc</kbd>
      close
    </span>
  </footer>
</div>
